module.exports = __webpack_public_path__ + "fcaf6e2627617e34bdfc5fecf35fc497.svg";